// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const Success: React.FC = () => {
//   const navigate = useNavigate();
//   const [seconds, setSeconds] = useState(5);

//   const redirectPath =
//     localStorage.getItem("postLoginRedirect") || "/dashboard";

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setSeconds((prev) => prev - 1);
//     }, 1000);

//     const redirectTimer = setTimeout(() => {
//       localStorage.removeItem("postLoginRedirect");
//       navigate(redirectPath);
//     }, 5000); // change to 10000 for 10 sec

//     return () => {
//       clearInterval(timer);
//       clearTimeout(redirectTimer);
//     };
//   }, [navigate, redirectPath]);

//   return (
//     <div className="d-flex flex-column align-items-center justify-content-center vh-100">
//       <h1 className="text-success">✅ Payment Successful</h1>
//       <p>Your Test Series is now active.</p>

//       <p className="text-muted">
//         Redirecting in {seconds} seconds...
//       </p>

//       <button
//         className="btn btn-primary mt-3"
//         onClick={() => navigate(redirectPath)}
//       >
//         Go to Test Series
//       </button>
//     </div>
//   );
// };

// export default Success;
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../PaymentStatus.css";

const Success: React.FC = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(5);
  const redirectPath = localStorage.getItem("postLoginRedirect") || "/dashboard";

  useEffect(() => {
    const timer    = setInterval(() => setSeconds(p => p - 1), 1000);
    const redirect = setTimeout(() => { localStorage.removeItem("postLoginRedirect"); navigate(redirectPath); }, 5000);
    return () => { clearInterval(timer); clearTimeout(redirect); };
  }, [navigate, redirectPath]);

  return (
    <div className="pst-page pst-success">
      <div className="pst-card">
        {/* Animated tick */}
        <div className="pst-icon-wrap pst-icon-success">
          <svg className="pst-icon-svg" viewBox="0 0 52 52">
            <circle className="pst-circle pst-circle-success" cx="26" cy="26" r="25" fill="none" strokeWidth="2" />
            <path className="pst-tick" fill="none" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M14 27 l8 8 l16-16" />
          </svg>
        </div>

        <h1 className="pst-title pst-title-success">Payment Successful!</h1>
        <p className="pst-subtitle">Your test series is now active and ready to use.</p>

        {/* What's next */}
        <div className="pst-next-steps">
          <div className="pst-next-title">What's next?</div>
          <div className="pst-next-list">
            <div className="pst-next-item">
              <span className="pst-next-num">1</span>
              <div>
                <div className="pst-next-head">Access your tests</div>
                <div className="pst-next-desc">Find all purchased tests in My Tests dashboard</div>
              </div>
            </div>
            <div className="pst-next-item">
              <span className="pst-next-num">2</span>
              <div>
                <div className="pst-next-head">Start practising</div>
                <div className="pst-next-desc">Attempt mock tests and track your performance</div>
              </div>
            </div>
            <div className="pst-next-item">
              <span className="pst-next-num">3</span>
              <div>
                <div className="pst-next-head">Review your analysis</div>
                <div className="pst-next-desc">Check detailed solutions and all-India rankings</div>
              </div>
            </div>
          </div>
        </div>

        {/* Countdown */}
        <div className="pst-countdown">
          <div className="pst-countdown-ring" style={{ "--pct": `${(seconds / 5) * 100}%` } as React.CSSProperties}>
            <span className="pst-countdown-num">{seconds}</span>
          </div>
          <span className="pst-countdown-text">Redirecting to your dashboard…</span>
        </div>

        <div className="pst-actions">
          <button className="pst-btn-primary" onClick={() => navigate(redirectPath)}>
            Go to My Tests →
          </button>
          <Link to="/" className="pst-btn-ghost">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
